import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';

interface IFullPageLoadingProps {
  text?: string;
}

const style = (theme: Theme) =>
  createStyles({
    progress: { flexGrow: 1 },
    root: { height: '100%', width: '100%' },
    text: { paddingBottom: theme.spacing(), textAlign: 'center' }
  });

type FullPageLoadingProps = IFullPageLoadingProps & WithStyles<typeof style>;
export const FullPageLoading = withStyles(style)(({ text = 'Loading...', classes }: FullPageLoadingProps) => (
  <Grid container alignContent="center" alignItems="center" className={classes.root}>
    <Grid item className={classes.progress}>
      <Typography variant="h5" className={classes.text}>
        {text}
      </Typography>
      <LinearProgress />
    </Grid>
  </Grid>
));
